import axios from "../../utils/axios";

export async function getJob(id) {
  const response = await axios.get(`/jobs/${id}`);
  return response.data;
}

export async function editJob(id, data) {
  const response = await axios.patch(`/jobs/${id}`, data);
  return response.data;
}
